import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Subject, Observable } from 'rxjs';

import { LMBannerHeaderComponent } from './lm-banner-header.component';

/**
 * Special service used by a "root router-outlet component": i.e. ListComponent, FormComponent. etc...
 * to set the banner headers toolbar options and state.
 */
@Injectable()
export class LMBannerHeaderComponentRef {
  private m_bannerHeaderComponent: LMBannerHeaderComponent;

  public set instance(bannerHeaderComponent: LMBannerHeaderComponent) {
    this.m_bannerHeaderComponent = bannerHeaderComponent;
  }

  public get instance(): LMBannerHeaderComponent {
    return this.m_bannerHeaderComponent;
  }

  constructor(private location: Location) {
    // TODO: WIP make browser back/forward button work
    // to bring back state of backReferences
    // this.location.subscribe((value: PopStateEvent) => {
    //   console.log(value);
    // });
  }

  // back reference stack maintained in LIFO manner
  private backReferences: BackReference[] = [];
  private backRefChanges = new Subject<BackReferenceChange>();

  public get backReferenceChanges$(): Observable<BackReferenceChange> {
    return this.backRefChanges.asObservable();
  }

  public pushBackReference(id: string, title: string) {
    const backTitle = this.instance.toolbarSectionTitle;

    this.instance.showGoBack = true;
    this.instance.toolbarSectionTitle = title;

    const backReference = { id, backTitle };
    this.backReferences.push(backReference);
    this.backRefChanges.next({ action: 'push', backReference });

    // TODO: WIP make browser back/forward button work
    // const currentPath = this.location.path();
    // this.location.go(`${currentPath}#${id}`, '', backReference);
  }

  public popBackReference() {
    if (!this.backReferences.length) {
      return;
    };

    const backReference = this.backReferences.pop();
    this.instance.toolbarSectionTitle = backReference.backTitle;
    this.backRefChanges.next({ action: 'pop', backReference });

    if (!this.backReferences.length) {
      this.instance.showGoBack = false;
    }
    // TODO: WIP make browser back/forward button work
    // this.location.back();
  }

  public lastBackReference(): BackReference {
    const length = this.backReferences.length;
    if (!length) {
      return null;
    }

    return this.backReferences[ length - 1 ];
  }

  public resetBackReferences() {
    if (this.backReferences.length) {
      this.instance.toolbarSectionTitle = this.backReferences[0].backTitle;
      this.instance.showGoBack = false;
      this.backReferences = [];
    }
    this.backRefChanges.next({ action: 'reset' });
  }
}
